module.exports = __webpack_public_path__ + "static/media/Karen.efebfc2e.md";